export default __webpack_public_path__ + "static/media/donate-05.8408b2e2.png";